import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  CustomFieldSuggestionQuery,
  ListCustomFieldSuggestionsOptions,
  ListCustomFieldSuggestionsResponse,
  QueryCustomFieldSuggestionsResponse,
  SuggestionsQueryBuilder,
  listCustomFieldSuggestions as universalListCustomFieldSuggestions,
  queryCustomFieldSuggestions as universalQueryCustomFieldSuggestions,
  typedQueryCustomFieldSuggestions as universalTypedQueryCustomFieldSuggestions,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/members' };

export function listCustomFieldSuggestions(
  httpClient: HttpClient
): ListCustomFieldSuggestionsSignature {
  return (options?: ListCustomFieldSuggestionsOptions) =>
    universalListCustomFieldSuggestions(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListCustomFieldSuggestionsSignature {
  /**
   * Retrieves a list of suggestions for both custom fields and existing fields available from the Wix Members Area.
   */
  (options?: ListCustomFieldSuggestionsOptions): Promise<
    NonNullablePaths<
      ListCustomFieldSuggestionsResponse,
      | `suggestions`
      | `suggestions.${number}.defaultPrivacy`
      | `suggestions.${number}.fieldType`
      | `suggestions.${number}.socialType`
      | `suggestions.${number}.fieldOrigin`,
      4
    >
  >;
}

export function queryCustomFieldSuggestions(
  httpClient: HttpClient
): QueryCustomFieldSuggestionsSignature {
  return () =>
    universalQueryCustomFieldSuggestions(
      // @ts-ignore
      { httpClient }
    );
}

interface QueryCustomFieldSuggestionsSignature {
  /**
   * Retrieves a list of up to 100 custom field suggestions, given the provided filters, fieldsets, sorting and paging, and returns a [`SuggestionsQueryBuilder`](https://dev.wix.com/docs/sdk/backend-modules/members/custom-field-suggestions/suggestions-query-builder/find) object.
   *
   * The returned object contains the query definition which is typically used to run the query using the [`find()`](https://dev.wix.com/docs/sdk/backend-modules/members/custom-field-suggestions/suggestions-query-builder/find) method.
   *
   * You can refine the query by chaining `SuggestionsQueryBuilder` methods onto the query. `SuggestionsQueryBuilder` methods enable you to sort, filter, and control the results that `queryCustomFieldSuggestions()` returns. The methods that are chained to `queryCustomFieldSuggestions()` are applied in the order they are called.
   *
   * `queryCustomFieldSuggestions()` runs with the following `SuggestionsQueryBuilder` defaults that you can override:
   * - [`skip`: `0`](https://dev.wix.com/docs/sdk/backend-modules/members/custom-field-suggestions/suggestions-query-builder/skip)
   * - [`limit`: `50`](https://dev.wix.com/docs/sdk/backend-modules/members/custom-field-suggestions/suggestions-query-builder/limit)
   *
   *
   */
  (): SuggestionsQueryBuilder;
}

export function typedQueryCustomFieldSuggestions(
  httpClient: HttpClient
): TypedQueryCustomFieldSuggestionsSignature {
  return (query: CustomFieldSuggestionQuery) =>
    universalTypedQueryCustomFieldSuggestions(
      query,
      // @ts-ignore
      { httpClient }
    );
}

interface TypedQueryCustomFieldSuggestionsSignature {
  /** */
  (query: CustomFieldSuggestionQuery): Promise<
    NonNullablePaths<
      QueryCustomFieldSuggestionsResponse,
      | `suggestions`
      | `suggestions.${number}.defaultPrivacy`
      | `suggestions.${number}.fieldType`
      | `suggestions.${number}.socialType`
      | `suggestions.${number}.fieldOrigin`,
      4
    >
  >;
}

export {
  CustomFieldSuggestion,
  CustomFieldSuggestionQuerySpec,
  ListCustomFieldSuggestionsOptions,
  ListCustomFieldSuggestionsRequest,
  ListCustomFieldSuggestionsResponse,
  Origin,
  Paging,
  PagingMetadata,
  Privacy,
  Query,
  QueryCustomFieldSuggestionsRequest,
  QueryCustomFieldSuggestionsResponse,
  SocialTypeType,
  SortOrder,
  Sorting,
  SuggestionsQueryBuilder,
  SuggestionsQueryResult,
  Type,
  utils,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';
